import $ from 'jquery';

const footer = () => {
  $('.footer-content-copyright > span').html(new Date().getFullYear());
};

export default () => {
  footer();
};
